"use client";

import BannerPopup from "@/components/BannerPopup";
import { useGetBanner } from "@/api/useGetBannerApi";
import { useGetSiteId } from "@/api/useGetSiteApi";

const BannerPopupLayer = () => {
  const { siteId } = useGetSiteId();
  const { bannerList } = useGetBanner(siteId);

  return <BannerPopup bannerList={bannerList} />;
};

export default BannerPopupLayer;
